import * as PropTypes from "prop-types";
import React from "react";
import {
  Chart,
  Legend,
  PieSeries,
  Tooltip,
} from "@devexpress/dx-react-chart-material-ui";
import { Animation, EventTracker } from "@devexpress/dx-react-chart";
import { styled } from '@mui/system';

// Use the styled function from '@mui/system' correctly
const StyledLegendRoot = styled(Legend.Root)(({ theme }) => ({
  maxHeight: "300px",
  minHeight: "300px",
  overflowX: "auto",
  width: "100%",
}));

const StyledLegendLabel = styled(Legend.Label)(({ theme }) => ({
  whiteSpace: "nowrap",
}));

const DonutChart = (props) => {
  const { data, valueField, argumentField, t, translationPath } = props;

  const filteredData = data.filter((item) => item.value !== 0);

  const translatedData = filteredData.map((item) => ({
    ...item,
    title: `${t(`${translationPath}.${item.title}`)}: ${item.value}`, 
  }));

  return (
    <Chart data={translatedData}>
      <PieSeries
        valueField={valueField}
        argumentField={argumentField}
        innerRadius={0.5}
      />
      <Animation />
      <Legend 
        position="bottom"
        rootComponent={StyledLegendRoot}
        labelComponent={StyledLegendLabel}
      />
      <EventTracker />
      <Tooltip />
    </Chart>
  );
};

DonutChart.propTypes = {
  data: PropTypes.array.isRequired,
  valueField: PropTypes.string.isRequired,
  argumentField: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  translationPath: PropTypes.string.isRequired,
};

export { DonutChart };